import { render } from "./SlidersIcon.vue?vue&type=template&id=81887b0e&ts=true"
import script from "./SlidersIcon.vue?vue&type=script&lang=ts"
export * from "./SlidersIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__